import React from 'react';

export const AppLazyLoad = React.lazy(() => import('./App'));